// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Main-module--cls1--1H2I2","cls2":"Main-module--cls2--8JnsM Main-module--cls1--1H2I2"};